import { useMemo } from "react";

import { Field, Label, Description } from "V2.0/common/fieldset";
import { MultiListbox } from "V2.0/components/MultiListBox";

export default SourceAssistants;

function SourceAssistants(props) {
  const { assistants, selectedAssistant, updateSelectedAssistants, disabled } = props;

  const assistantsByChannel = useMemo(() => {
    return assistants.reduce(
      (acc, assistant) => {
        const { assistantType } = assistant;

        return {
          ...acc,
          [assistantType]: [
            ...(acc[assistantType] ?? []),
            { id: assistant._id, value: assistant._id, label: assistant.name },
          ],
        };
      },

      {
        voice: [],
        chat: [],
        instagram: [],
        messenger: [],
        whatsapp: [],
        email: [],
      },
    );
  }, [assistants]);

  const assistantChannelOptions = useMemo(() => {
    const { voice, chat, instagram, messenger, whatsapp } = assistantsByChannel;

    return [
      ...(voice.length > 0
        ? [{ label: "Voice", options: voice, sticky: true }]
        : []),
      ...(chat.length > 0
        ? [{ label: "SMS", options: chat, sticky: true }]
        : []),
      ...(instagram.length > 0
        ? [{ label: "Instagram", options: instagram, sticky: true }]
        : []),
      ...(messenger.length > 0
        ? [{ label: "Messenger", options: messenger, sticky: true }]
        : []),
      ...(whatsapp.length > 0
        ? [{ label: "Whatsapp", options: whatsapp, sticky: true }]
        : []),
    ];
  }, [assistantsByChannel]);

  return (
    <Field>
    <Label>Source Assistants (Conversations)</Label>
    <Description>Select which assistant conversations should be included as context for responses</Description>
    <MultiListbox
      value={selectedAssistant}
      defaultValue={selectedAssistant}
      onChange={(value) => updateSelectedAssistants(value)}
      options={assistantChannelOptions}
      disabled={disabled}
    />
    </Field>
  );
}
